import React from "react";
import { Box, Button, Stack } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { GlassButton } from "../themes/UiElements";

const CursorNavButtons = ({ cursors = {}, onNav }) => {
  const handleBeforeClick = () => {
    if (cursors.before && onNav) {
      onNav(`before=${cursors.before}`);
    }
  };

  const handleAfterClick = () => {
    if (cursors.after && onNav) {
      onNav(`after=${cursors.after}`);
    }
  };

  return (
    <Box mt={2} display="flex" justifyContent="center">
      <Stack direction="row" spacing={2}>
        {cursors.before && (
          <GlassButton
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={handleBeforeClick}
          >
            Previous
          </GlassButton>
        )}
        {cursors.after && (
          <GlassButton
            variant="outlined"
            endIcon={<ArrowForwardIcon />}
            onClick={handleAfterClick}
          >
            Next
          </GlassButton>
        )}
      </Stack>
    </Box>
  );
};

export default CursorNavButtons;
